import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom'
import ReactGA from 'react-ga';
import asyncComponent from './AsyncComponent';

import './App.css';

ReactGA.initialize('UA-115773212-1');

const Analytics = (props) => {
    ReactGA.set({ page: props.location.pathname + props.location.search });
    ReactGA.pageview(props.location.pathname + props.location.search);
    return null;
}


const App = () => {
    return (
        <Router>
            <div>
                <Route path="/" component={Analytics}/>
                <Route exact path="/" component={Home}/>
                <Route exact path="/stories" component={Stories}/>
                <Route exact path="/news" component={TwitterNews}/>
            </div>
        </Router>
    );
}

const Home = asyncComponent(() => import(/* webpackChunkName: "Home" */ './Home').then(module => module.default))
const Stories = asyncComponent(() => import(/* webpackChunkName: "Stories" */ './Stories').then(module => module.default))
const TwitterNews = asyncComponent(() => import(/* webpackChunkName: "TwitterNews" */ './TwitterNews').then(module => module.default))


export default App;



// WEBPACK FOOTER //
// ./src/App.js